<template>
    <div class="container">
        <div class="row justify-content-center mt-md-5">

            <connection-api-test-component
                v-if="this.$store.state.errorMessageResponse" :messageResponse="this.$store.state.errorMessageResponse">
            </connection-api-test-component>


            <div class="col-md-9  col-xl-8 ">

                <div class="card mt-5">
                    <div class="card-header">CADASTRO</div>
                    <div class="card-body">
                        <form method="POST" :action="route_register" @submit.prevent="register($event)" id="form-register">
                            <input type="hidden" name="_token" :value="csrf_token">

                            <div class="row mb-3">
                                <label for="name" class="col-md-4 col-form-label text-md-end">Nome</label>

                                <div class="col-md-6">
                                    <div class="input-group">
                                        <input id="name" name="name" type="text" class="form-control border-rigth-none"
                                               autocomplete='name' v-model="name">
                                        <VueCustomTooltip label="Como você gostaria de ser chamado?" multiline
                                                          size="is-medium" position="is-left">
                                            <svg fill="#FFFFFF" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
                                                 class="input-group-text input-group-image rounded-end border-start-0">
                                                <path
                                                    d="M12 3c-4.969 0-9 4.031-9 9s4.031 9 9 9 9-4.031 9-9-4.031-9-9-9Zm-.281 14.25a.938.938 0 1 1 0-1.875.938.938 0 0 1 0 1.875Zm1.567-4.781c-.76.51-.864.977-.864 1.406a.656.656 0 0 1-1.313 0c0-1.027.473-1.844 1.445-2.497.904-.606 1.415-.99 1.415-1.836 0-.574-.328-1.01-1.008-1.334-.16-.076-.515-.15-.953-.145-.55.007-.976.139-1.305.403-.62.499-.672 1.042-.672 1.05a.656.656 0 1 1-1.312-.064c.005-.114.084-1.14 1.16-2.006.56-.449 1.27-.682 2.11-.693.595-.007 1.155.094 1.534.273 1.135.537 1.758 1.432 1.758 2.516 0 1.586-1.06 2.298-1.995 2.927Z"></path>
                                            </svg>
                                        </VueCustomTooltip>
                                    </div>

                                    <alert-error-message-component v-if="this.errors.name_error"
                                                                   :mesage="this.errors.name_error[0]">
                                    </alert-error-message-component>

                                </div>
                            </div>


                            <div class="row mb-3">
                                <label for="email" class="col-md-4 col-form-label text-md-end">Email</label>

                                <div class="col-md-6">
                                    <div class="input-group">
                                        <input id="email" type="text" name="email"
                                               class="form-control border-rigth-none border-end-0 rounded-start"
                                               autocomplete="email" v-model="email">
                                        <VueCustomTooltip
                                            label="Você precisa usar o mesmo e-mail do seu cadastro no ATIS." multiline
                                            size="is-medium" position="is-left">
                                            <svg fill="#FFFFFF" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
                                                 class="input-group-text input-group-image rounded-end border-start-0">
                                                <path
                                                    d="M12 3c-4.969 0-9 4.031-9 9s4.031 9 9 9 9-4.031 9-9-4.031-9-9-9Zm-.281 14.25a.938.938 0 1 1 0-1.875.938.938 0 0 1 0 1.875Zm1.567-4.781c-.76.51-.864.977-.864 1.406a.656.656 0 0 1-1.313 0c0-1.027.473-1.844 1.445-2.497.904-.606 1.415-.99 1.415-1.836 0-.574-.328-1.01-1.008-1.334-.16-.076-.515-.15-.953-.145-.55.007-.976.139-1.305.403-.62.499-.672 1.042-.672 1.05a.656.656 0 1 1-1.312-.064c.005-.114.084-1.14 1.16-2.006.56-.449 1.27-.682 2.11-.693.595-.007 1.155.094 1.534.273 1.135.537 1.758 1.432 1.758 2.516 0 1.586-1.06 2.298-1.995 2.927Z"></path>
                                            </svg>
                                        </VueCustomTooltip>
                                    </div>

                                    <alert-error-message-component v-if="this.errors.email_error"
                                                                   :mesage="this.errors.email_error[0]">
                                    </alert-error-message-component>

                                </div>
                            </div>

                            <div class="row mb-3">
                                <label for="password" class="col-md-4 col-form-label text-md-end">Senha</label>

                                <div class="col-md-6">
                                    <input id="password"  type="password" class="form-control border-rigth-none"
                                           name="password" autocomplete="new-password" v-model="password">

                                    <alert-error-message-component v-if="this.errors.password_error"
                                                                   :mesage="this.errors.password_error[0]">
                                    </alert-error-message-component>

                                </div>
                            </div>


                            <div class="row mb-3">
                                <label for="password-confirm" class="col-md-4 col-form-label text-md-end">Confirme a
                                    Senha </label>
                                <div class="col-md-6">
                                    <input id="password-confirm" type="password" class="form-control border-rigth-none"
                                           name="password_confirmation"
                                           autocomplete="new-password" v-model="password_confirm">

                                    <alert-error-message-component v-if="this.errors.password_confirmation_error"
                                                                   :mesage="this.errors.password_confirmation_error[0]">
                                    </alert-error-message-component>
                                </div>
                            </div>

                            <div class="row mb-0">
                                <div class="col-md-6 offset-md-4 d-flex justify-content-lg-end">
                                    <button type="submit"  class="btn btn-primary" v-if="!isLoader">Cadastrar</button>
                                    <button type="button"  class="btn btn-primary" v-if="isLoader" disabled>Aguarde</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

        </div>
    </div>

</template>

<script>


import VueCustomTooltip from '@adamdehaven/vue-custom-tooltip'

export default {

    name: "RegisterComponent",
    props: ['csrf_token', 'url_valida_login_atis', 'is_exist_email', 'route_register'],
    components: {
        VueCustomTooltip,
    },
    data() {
        return {
            isLoader: false,
            name: '',
            email: '',
            password: '',
            password_confirm: '',

            errors: {
                name_error: '',
                email_error: '',
                password_error: '',
                password_confirmation_error: '',
            }
        }
    },
    methods: {
         register(e) {

            this.formValidation(e).then((response) => {
                if (response) {
                   e.target.submit();
                }
            });

        },

        async formValidation() {

            if (this.name === '') {
                this.errors.name_error = ['O campo nome é obrigatório.']
                return false;
            } else {
                this.errors.name_error = ''
            }

            if (this.email === '') {
                this.errors.email_error = ['O campo email é obrigatório.']
                return false;
            } else {
                this.errors.email_error = ''
            }

            if (this.isEmail(this.email) === false) {
                this.errors.email_error = ['O campo email é inválido.']
                return false;
            } else {
                this.errors.email_error = ''
            }

            if (this.password === '') {
                this.errors.password_error = ['O campo senha é obrigatório.']
                return false;
            } else {
                this.errors.password_error = ''
            }

            if (this.password === '') {
                this.errors.password_error = ['A senha é obrigatória.']
                return false;
            } else {
                this.errors.password_error = ''
            }

            if (this.password_confirm === '') {
                this.errors.password_confirmation_error = ['O campo confirme a senha é obrigatório.']
                return false;
            } else {
                this.errors.password_confirmation_error = ''
            }

            if (this.password !== this.password_confirm) {
                this.errors.password_confirmation_error = ['As senhas não conferem.']
                return false;
            } else {
                this.errors.password_confirmation_error = ''
            }


            this.isLoader = true;
            let authorization = true;
            await axios.get(this.url_valida_login_atis + '/' + this.email)
                .then(response => {
                    if (!response.data.status) {
                        this.errors.email_error = ['Este e-mail não esta cadastrado no Atis ou não tem permissão para usar esse sistema.']
                        authorization =  false;
                    } else {
                        this.errors.email_error = ''
                    }
                })
                .catch(error => {
                    this.$store.state.errorMessageResponse = error.message;
                })

            if(authorization === false){
                this.isLoader = false;
                return false;
            }

            let existEmail = false;
            await axios.get(this.is_exist_email + '/' + this.email)
                .then(response => {
                    if (response.data.status) {
                        this.errors.email_error = ['O email informado já está cadastrado.']
                        existEmail  = true;
                    } else {
                        this.errors.email_error = ''
                    }
                })
                .catch(error => {
                    this.$store.state.errorMessageResponse = error.message;
                    return false;
                })

            if(existEmail){
                this.isLoader = false;
                return false;
            }


            return true;
        }
    },
    mounted() {
        this.inputOnlyNumbers('#saller_id');
    }

}
</script>


